import { createFileRoute } from '@tanstack/react-router'

import { DataAssetsPage } from '@/pages/data-assets/DataAssets.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/data-assets/',
)({
  component: DataAssetsPage,
})
